<div>
    <a href="#" [routerLink]="['/', 'orders', 'configurator-3d']" class="button" [class.disabled]="disabled$ | async">
        {{ 'btn-configurator-3d' | translate }}
    </a>

    <i class="pi pi-star-fill icon-1"></i>
    <i class="pi pi-star-fill icon-2"></i>
    <i class="pi pi-star-fill icon-3"></i>
</div>
